import React, { useState } from 'react';
import { Tag } from 'primereact';


import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid'


import { colorCotton, colorSintetico } from '../../../../../Styles/Colors';

export const InventarioQCScreen = ({ inventarioQC, loading }) => {


    const CategoriaTemplate = (rowData) => {
        switch (rowData.NombreTipo) {
            case 'Quimicos':
                return <Tag severity='danger' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorCotton }}/>
                break;
            case 'Colorantes':
                return <Tag severity='info' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorSintetico }}/>
                break;
            case 'Spandex':
                return <Tag className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: '#ffc605' }} />
                break;
        
            default:
                return <div>{rowData.NombreTipo}</div>
                break;
        }
    }

    const colums = [
        {
            header: 'Tipo',
            field: 'NombreTipo',
            className: 'small',
            Format: 'Template',
            body: CategoriaTemplate,
            frozen: true
        },
        {
            header: 'Codigo Producto',
            field: 'CodigoProducto',
            className: 'small',
            frozen: true
        },
        {
            header: 'Producto',
            field: 'NombreProducto',
            className: 'XXlarge',
            Sumary: 'count',
            frozen: true
        },
        {
            header: 'Categoria',
            field: 'NombreCategoria',
            className: 'medium'
        },
        {
            header: 'Antiguedad',
            field: 'AntiguedadText',
            Format: 'DateTime',
            className: 'small'
        },
        {
            header: 'Factura',
            field: 'Factura',
        },
        {
            header: 'Lote',
            field: 'Lote',
            className: 'small'
        },
        {
            header: 'Años',
            field: 'Años',
            className: 'Xsmall'
        },
        {
            header: 'Meses',
            field: 'Meses',
            className: 'Xsmall'
        },
        {
            header: 'Dias',
            field: 'Dias',
            className: 'Xsmall'
        },
        {
            header: 'Estado',
            field: 'Estado',
            className: 'small'
        },
        {
            header: 'Semana Recibido',
            field: 'SemanaRecibido',
            className: 'small'
        },
        {
            header: 'Ubicacion',
            field: 'Ubicacion',
            className: 'small'
        },

        {
            header: 'Comentarios',
            field: 'Comentarios',
            className: 'large'
        },
        {
            header: 'Inicial(Kgs)',
            field: 'Inicial',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            frozen: true,
            alignFrozen: 'right'
        },
        {
            header: 'Ingreso(Kgs)',
            field: 'Ingreso',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            frozen: true,
            alignFrozen: 'right'
        },
        {
            header: 'Salidas(Kgs)',
            field: 'Salidas',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            frozen: true,
            alignFrozen: 'right'
        },
        {
            header: 'CantidadInv(Kgs)',
            field: 'CantidadInv',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            frozen: true,
            alignFrozen: 'right'
        },

    ]

    const table = {
        Data: inventarioQC,
        Columns: colums,
        loading: loading
    }



    return (
        <div className='p-2' style={{ height: '85vh' }}>
            <AgGrid table={table} />
        </div>
    )
}
